import { render, staticRenderFns } from "./DataTruckList.vue?vue&type=template&id=b2a7ec26&scoped=true"
import script from "./DataTruckList.vue?vue&type=script&lang=js"
export * from "./DataTruckList.vue?vue&type=script&lang=js"
import style0 from "./DataTruckList.vue?vue&type=style&index=0&id=b2a7ec26&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a7ec26",
  null
  
)

export default component.exports